import * as Yup from 'yup';
import { errorMessages } from '~/constants/errorMessages.ts';
import {
  addressNotRequiredSchema,
  addressSchema,
  documentSchema,
  foreignTaxNumberSchema,
  nameSchema,
  notRequiredOptionSchema,
  requiredOptionSchema,
  RNOKPPIdentNumberSchema,
} from '../../validationSchemas';
import { getValidationFormValue } from '~/helpers/utils';
import { TManagmentStructure } from './types';

export const validationSchema = Yup.object().shape({
  lastName: nameSchema.required(errorMessages.FIELD_REQUIRED),
  firstName: nameSchema.required(errorMessages.FIELD_REQUIRED),
  middleName: nameSchema,
  birthDate: Yup.string().required(errorMessages.FIELD_REQUIRED),
  identificationNumber: RNOKPPIdentNumberSchema('foreignTaxNumber'),
  foreignTaxNumber: foreignTaxNumberSchema('identificationNumber'),
  citizenshipCountry: requiredOptionSchema,
  residenceCountry: requiredOptionSchema,
  birthCountry: requiredOptionSchema,
  birthPlace: Yup.string()
    .required(errorMessages.FIELD_REQUIRED)
    .max(120, errorMessages.MAX_LENGTH(120)),
  documents: documentSchema,
  position: requiredOptionSchema,
  address: Yup.object().shape({
    registrationAddress: addressSchema,
    permanentAddress: addressSchema,
    coincidences: Yup.boolean().nullable(),
  }),
  isAccountHolder: Yup.boolean().required(errorMessages.YES_NO_REQUIRED),
  hasNoGoverningPersons: Yup.boolean().nullable(),
  isHeadNew: Yup.boolean().nullable(),
  isInBankBlackList: Yup.boolean().nullable(),
  isInTerList: Yup.boolean().nullable(),
  governingPersons: Yup.array()
    .of(
      Yup.object().shape({
        lastName: Yup.string()
          .nullable()
          .when('hasNoGoverningPersons', function ([], schema, options) {
            return getValidationFormValue<TManagmentStructure>(options, 1)?.hasNoGoverningPersons
              ? schema.nullable().notRequired()
              : nameSchema.required(errorMessages.FIELD_REQUIRED);
          }),
        firstName: Yup.string()
          .nullable()
          .when('hasNoGoverningPersons', function ([], schema, options) {
            return getValidationFormValue<TManagmentStructure>(options, 1)?.hasNoGoverningPersons
              ? schema.nullable().notRequired()
              : nameSchema.required(errorMessages.FIELD_REQUIRED);
          }),
        middleName: Yup.string()
          .nullable()
          .when('hasNoGoverningPersons', function ([], schema, options) {
            return getValidationFormValue<TManagmentStructure>(options, 1)?.hasNoGoverningPersons
              ? schema.nullable().notRequired()
              : nameSchema;
          }),
        identificationNumber: Yup.string()
          .nullable()
          .when('hasNoGoverningPersons', function ([], _, options) {
            return RNOKPPIdentNumberSchema(
              '',
              getValidationFormValue<TManagmentStructure>(options, 1)?.hasNoGoverningPersons
            );
          }),
        birthDate: Yup.string()
          .nullable()
          .when('hasNoGoverningPersons', function ([], schema, options) {
            return getValidationFormValue<TManagmentStructure>(options, 1)?.hasNoGoverningPersons
              ? schema.nullable().notRequired()
              : schema.required(errorMessages.FIELD_REQUIRED);
          }),
        citizenshipCountry: Yup.object().when('hasNoGoverningPersons', function ([], _, options) {
          return getValidationFormValue<TManagmentStructure>(options, 1)?.hasNoGoverningPersons
            ? notRequiredOptionSchema
            : requiredOptionSchema;
        }),
        residenceCountry: Yup.object().when('hasNoGoverningPersons', function ([], _, options) {
          return getValidationFormValue<TManagmentStructure>(options, 1)?.hasNoGoverningPersons
            ? notRequiredOptionSchema
            : requiredOptionSchema;
        }),
        position: Yup.object().when('hasNoGoverningPersons', function ([], _, options) {
          return getValidationFormValue<TManagmentStructure>(options, 1)?.hasNoGoverningPersons
            ? notRequiredOptionSchema
            : requiredOptionSchema;
        }),
        address: Yup.object().shape({
          registrationAddress: Yup.object()
            .when('hasNoGoverningPersons', function ([], _, options) {
              return getValidationFormValue<TManagmentStructure>(options, 2)?.hasNoGoverningPersons
                ? addressNotRequiredSchema
                : addressSchema;
            })
            .nullable(),
          permanentAddress: Yup.object()
            .when('hasNoGoverningPersons', function ([], _, options) {
              return getValidationFormValue<TManagmentStructure>(options, 2)?.hasNoGoverningPersons
                ? addressNotRequiredSchema
                : addressSchema;
            })
            .nullable(),
          coincidences: Yup.boolean().nullable(),
        }),
      })
    )
    .nullable(),
});
